import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSkeletonMedium = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 228 49" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#C2C5CC"
        d="M7 19h1v30H7zM25 7h203v1H25zm0 15h126v1H25zm0 15h102v1H25z"
      />
      <circle stroke="#C2C5CC" cx={7} cy={7} r={6.5} />
    </g>
  </svg>
);
const Memo = memo(SvgSkeletonMedium);
export default Memo;
